'use strict';

const _ = require('lodash');
const moment = require('moment');

const edit = (data) => {
    const billing = _.get(data, 'settings.billing');
    const type = _.get(data, 'encounter.document.type');
    const end = _.get(data, 'encounter.document.encounterEndTime');
    const sub = _.get(data, 'profile.sub');
    const author = _.get(data, 'encounter.author_id');
    const roles = _.get(data, 'profile.app_metadata.roles', []);
    const role = roles?.meta?.role;
    const isAdmin = [
        'administrator',
        'executive_director',
        'medical_director'
    ].includes(role);

    return (
        (billing &&
            ['home', 'phone', 'mobile', 'email', 'administrative'].indexOf(
                type
            ) >= 0 &&
            end &&
            moment(end) > moment(billing) &&
            sub &&
            author &&
            sub === author) ||
        isAdmin
    );
};

module.exports = {
    edit
};
